import React, { useState, useCallback, useRef } from 'react';
import './gallery.css';

const Gallery = ({ galleryId = "gallery" }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  // Data galérie - každý slide má 2 obrázky
  const gallerySlides = [
    {
      images: [
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image23.webp",
          alt: "Fitness centrum 1"
        },
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image17.webp",
          alt: "Fitness centrum 2"
        }
      ]
    },
    {
      images: [
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image19.webp",
          alt: "Fitness centrum 3"
        },
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image24.webp",
          alt: "Fitness centrum 4"
        }
      ]
    },
    {
      images: [
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image26.webp",
          alt: "Fitness centrum 5"
        },
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image25.webp",
          alt: "Fitness centrum 6"
        }
      ]
    },
    {
      images: [
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image22.webp",
          alt: "Fitness centrum 7"
        },
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image21.webp",
          alt: "Fitness centrum 8"
        }
      ]
    },
    {
      images: [
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image20.webp",
          alt: "Fitness centrum 9"
        },
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image18.webp",
          alt: "Fitness centrum 10"
        }
      ]
    },
    {
      images: [
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image16.webp",
          alt: "Fitness centrum 11"
        },
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image10.webp",
          alt: "Fitness centrum 12"
        }
      ]
    },
    {
      images: [
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image14.webp",
          alt: "Fitness centrum 13"
        },
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image13.webp",
          alt: "Fitness centrum 14"
        }
      ]
    },
    {
      images: [
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image12.webp",
          alt: "Fitness centrum 15"
        },
        {
          src: "https://fitelites3.s3.eu-central-1.amazonaws.com/images/image11.webp",
          alt: "Fitness centrum 16"
        }
      ]
    }
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % gallerySlides.length);
  }, [gallerySlides.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + gallerySlides.length) % gallerySlides.length);
  }, [gallerySlides.length]);

  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  // Touch handlers pro swipe
  const handleTouchStart = useCallback((e) => {
    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = e.touches[0].clientX;
  }, []);

  const handleTouchMove = useCallback((e) => {
    touchEndX.current = e.touches[0].clientX;
  }, []);

  const handleTouchEnd = useCallback(() => {
    if (!touchStartX.current || !touchEndX.current) return;
    
    const distance = touchStartX.current - touchEndX.current;
    const minSwipeDistance = 50;

    if (Math.abs(distance) > minSwipeDistance) {
      if (distance > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }

    touchStartX.current = 0;
    touchEndX.current = 0;
  }, [nextSlide, prevSlide]);

  return (
    <div id={galleryId} className="gallery-gallery3 thq-section-padding">
      <div className="gallery-max-width thq-section-max-width">
        {/* Header */}
        <div className="gallery-section-title">
          <h2 className="gallery-text10 thq-heading-1">Galerie</h2>
          <span className="gallery-text11 thq-body-large">
            <span>Prohlédněte si </span>
            <span className="gallery-text14">naši </span>
            <span className="gallery-text15">galerii </span>
            <span>a nahlédněte do světa našeho </span>
            <span className="gallery-text17">fitness centra</span>
            <span className="gallery-text18">! </span>
            <span>Inspirujte se a </span>
            <span className="gallery-text20">přidejte se k nám!</span>
          </span>
        </div>

        {/* Gallery Slider */}
        <div className="gallery-container10">
          <div className="gallery-content">
            <div className="gallery-slider-container">
              {/* Slider wrapper */}
              <div 
                className="gallery-slider-wrapper"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                {/* Current slide */}
                <div className="gallery-slider-track">
                  <div className="gallery-slider-slide">
                    <div className="gallery-image-container">
                      <img
                        src={gallerySlides[currentSlide].images[0].src}
                        alt={gallerySlides[currentSlide].images[0].alt}
                        className="gallery-image"
                        loading="lazy"
                      />
                    </div>
                    <div className="gallery-image-container">
                      <img
                        src={gallerySlides[currentSlide].images[1].src}
                        alt={gallerySlides[currentSlide].images[1].alt}
                        className="gallery-image"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation Arrows */}
              <button
                className="gallery-nav-btn gallery-nav-prev"
                onClick={prevSlide}
                aria-label="Předchozí slide"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button
                className="gallery-nav-btn gallery-nav-next"
                onClick={nextSlide}
                aria-label="Další slide"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
                </svg>
              </button>

              {/* Dots Navigation */}
              <div className="gallery-dots">
                {gallerySlides.map((_, index) => (
                  <button
                    key={index}
                    className={`gallery-dot ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                    aria-label={`Přejít na slide ${index + 1}`}
                  />
                ))}
              </div>

              {/* Counter */}
              <div className="gallery-counter">
                {currentSlide + 1} / {gallerySlides.length}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;